export default __webpack_public_path__ + "static/media/carnet.0a3962ac.png";